import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import PopupCloseBtn from 'styles/staticAssets/images/PopupCloseBtn.svg';
import ArrowIcon from 'styles/staticAssets/images/ArrowIcon.svg';
import ImageComponent from 'atoms/Image/index';
import { NavItemComp } from 'atoms/NavItems/Presentation/NavItemComp';
import HEADER_CONSTANT from '../HeaderConstants/HeaderConstant';
import { ReactSVG } from 'react-svg';
import { SelectOptions } from 'atoms/DropDown';
import Stripes_Small_OffersIcon from 'styles/staticAssets/images/Stripes_Small_OffersIcon.svg';
import { modifyLanguageData } from '../HeaderUtilities/HeaderUtils';
import { isEmptyObject, getFromLocalStorage } from 'common/utilities/utils';
import { FooterListComp } from '../../FooterComponent/Presentation/FooterListComp';
import SharedConstants, { USER_SELECTED_LANGUAGE } from 'common/constants/SharedConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { Config } from '../../../common/constants/SharedConstants';
import { ChannelManager } from 'common/manager';
import { login } from 'common/utilities/LoginUtils';

/* get SignInName for Analytics */
const getSignInName = (signInText, itemName) => {
  const { LOGGEDIN_USER_SINGIN_TEXT } = HEADER_CONSTANT;
  const { ANALYTICS_LOCALISATION_SIGNIN } = START_ORDER_CONSTANTS;
  if (signInText !== translateWithI18Next(LOGGEDIN_USER_SINGIN_TEXT)) {
    localStorage.setItem(ANALYTICS_LOCALISATION_SIGNIN, JSON.stringify(true));
    login();
  }
  return signInText === translateWithI18Next(LOGGEDIN_USER_SINGIN_TEXT) ? signInText : itemName;
};

/* get CartName for Analytics */
const getCartName = cartText => cartText.split(' ')[0] || HEADER_CONSTANT.CART_ALT_TEXT;

/**
 * Main HeaderMenu Items Component
 * @param {*} props - Object - title
 */
const HeaderMenu = props => {
  const {
    idx: id = '',
    className = '',
    handleClose = null,
    onItemsClickHandler = null,
    contentData = {},
    userParams = {},
  } = props;
  const { navLeft = [], navRight = [], navMobileMenu = {} } = contentData;
  const { letsGetCookingText = '', supportCategory = {} } = navMobileMenu;
  const languageSelector = modifyLanguageData(navRight);
  const { SIGN_IN_LINK, GUEST_USER_SINGIN_TEXT, LOGGEDIN_USER_SINGIN_TEXT, CART_ICON_100_PERCENT } = HEADER_CONSTANT;
  const signInText = userParams.loggedIn
    ? translateWithI18Next(LOGGEDIN_USER_SINGIN_TEXT)
    : translateWithI18Next(GUEST_USER_SINGIN_TEXT);
  const { defaultLanguage, allowedLanguages, COUNTRY } = useSelector(
    ({ tenantReducer: { basic: { allowedLanguages = [], defaultLanguage } = {}, country: COUNTRY = '' } = {} }) => ({
      allowedLanguages,
      defaultLanguage,
      COUNTRY,
    }),
  );
  const [selectedValue, setSelectedValue] = useState();

  const { cartReducer } = useSelector(data => {
    return {
      cartReducer: data.cartReducer || {},
    };
  });
  const { cartData = [] } = cartReducer || {};

  const { foodLines = [] } = cartData || {};
  const [cartCount, setCartCount] = useState(_.reduce(foodLines, (s, n) => s + n.quantity, 0));

  useEffect(() => {
    const localStorageLanguage = allowedLanguages.find(
      item => item.key === getFromLocalStorage(`${COUNTRY}_${USER_SELECTED_LANGUAGE}`),
    );
    !!COUNTRY && setSelectedValue((localStorageLanguage || {}).value || (defaultLanguage || {}).value);

    setCartCount(_.reduce(foodLines, (s, n) => s + n.quantity, 0));
  }, [COUNTRY, defaultLanguage, allowedLanguages, foodLines]);

  /*  draw left nav items */
  const leftNavItems = () => {
    return navLeft.map((item, ind) => {
      return (
        <div
          className='row'
          key={ind}
          onKeyPress={event => onKeyPressHandler(event, item.name)}
          onClick={() => onItemsClickHandler(item.name)}
        >
          <div className='header-card d-flex'>
            <div className='header-card-name' href={item.linkTo} id={ind} tabIndex='0'>
              {item.name}
            </div>
            <div
              className='header-card-image'
              style={{
                backgroundImage: `url(${item.imageUrl})`,
              }}
            ></div>
          </div>
        </div>
      );
    });
  };

  /*  draw support items */
  const supportcategoryItems = () => {
    return (
      <FooterListComp
        className='footer-links'
        data-testid='footerItemCat-component'
        onClickHandler={onItemsClickHandler}
        {...supportCategory}
      />
    );
  };

  /**
   * On Key Press Handler
   * @param {*} evt - Event Object
   */
  const onKeyPressHandler = (evt, name) => {
    // Char Code - Space and Enter
    const { SPACE, ENTER } = SharedConstants.KEY_CHAR_CODE;
    if (evt.charCode === SPACE || evt.charCode === ENTER) {
      // if onItemsClickHandler is a method
      onItemsClickHandler(name);
    }
  };

  const isUserNotSignedIn = !(ChannelManager.isGoogle && userParams.loggedIn);

  return (
    <div id={id} className={className}>
      <div className='nav mobile-modal-header' data-testid='mobileHeader-component'>
        <NavItemComp className='hamburger-close-btn' data-testid='hamburger-close' onClickHandler={handleClose}>
          <ImageComponent srcFile={PopupCloseBtn} alt={'close'} />
        </NavItemComp>
        <span className='headerLogoMobile'>
          <ReactSVG src={Stripes_Small_OffersIcon} />
        </span>
        {navRight.map(item => {
          if (item.url && item.title === CART_ICON_100_PERCENT) {
            return (
              <NavItemComp onClickHandler={onItemsClickHandler} className='cart-image' name={getCartName(item.altText)}>
                <ImageComponent srcFile={item.url || item.imageUrl} className='navRightIcons mobCartIcon' />
                <span className={'mobileCartIconCount hamburger-count'}>
                  {cartCount > 99 ? (
                    <span className='cart-icon-plus'>
                      99<span className='cartPlus'>+</span>
                    </span>
                  ) : (
                    cartCount
                  )}
                </span>
              </NavItemComp>
            );
          }
        })}
      </div>
      <div className='mobile-modal-body'>
        <div className='content'>
          <div className='title-container'>
            <div className='title-text'>{translateWithI18Next(letsGetCookingText.name)}</div>
            <div className='lang-div'>
              {isEmptyObject(languageSelector) && (
                <NavItemComp
                  onClickHandler={onItemsClickHandler}
                  name={languageSelector.type || languageSelector.name || 'cart'}
                >
                  <SelectOptions
                    options={allowedLanguages.map(itemval => itemval?.short_value?.toLowerCase())}
                    className='language-select'
                    selectedValue={selectedValue}
                  />
                  <span className='dropdown-img-ham' />
                </NavItemComp>
              )}
            </div>
          </div>
          <div className='signup-container' data-id={isUserNotSignedIn ? Config.HEADER_SIGN_IN_ATTR_DATA_ID : ''}>
            {navRight.map(item => {
              if (item.title && item.title.toUpperCase() === SIGN_IN_LINK) {
                return (
                  <div
                    onKeyPress={event => onKeyPressHandler(event, getSignInName(signInText, item.name))}
                    onClick={() => onItemsClickHandler(getSignInName(signInText, item.name))}
                  >
                    <ImageComponent srcFile={item.url || item.imageUrl} className='navRightIcons' />
                    <span>{translateWithI18Next(signInText)}</span>
                    <ImageComponent srcFile={ArrowIcon} className='navRightIcons arrow' />
                  </div>
                );
              }
            })}
          </div>
          <div className='navItemsLeft'>{leftNavItems()}</div>
          <div className='support-div'>{supportcategoryItems()}</div>
        </div>
      </div>
    </div>
  );
};

export { HeaderMenu };
